/* eslint-disable */
import React, { Component } from 'react';
import styled from 'styled-components';
import Text from '~/components/Text';
import H1 from '~/components/Headline';
import Closer from './Closer';

const Headline = styled(H1)`
  margin-top: 30px;
  margin-bottom: 15px;
`;

class FAQ extends Component {
  render() {
    return (
      <>
        <Closer setInfoboxContent={this.props.setInfoboxContent} />
        <Headline style={{ marginTop: 0 }}>Was zeigt die Grafik?</Headline>
        <Text>
          Die Grafik enthält alle in Deutschland ausgeübten Berufe mit mehr als
          10 gemeldeten offenen Stellen. Die Größe der Kreise steht für die Zahl
          der Beschäftigten in dem jeweiligen Beruf. Die Farbe steht für die
          typischerweise erforderliche Qualifikation in diesem Beruf. Berufe,
          die ohne Ausbildung ausgeübt werden können, sind blau, Berufe mit
          Ausbildung grün, mit Fortbildung (z.B. Meister, Techniker) oder
          Bachelor gelb, mit Master oder Diplom violett. Die x-Achse zeigt, wie
          viele Arbeitslose mit dem jeweiligen Beruf auf 100 offene Stellen in
          diesem Beruf kommen. Wenn es weniger Arbeitslose als offene Stellen
          gibt, besteht ein Fachkräftengpass. Je weiter rechts ein Kreis in der
          Grafik liegt, desto besser sind die Beschäftigungschancen für
          Bewerber. Die y-Achse zeigt den mittleren Bruttolohn in Euro pro Monat
          für eine Vollzeitstelle, das heißt, die eine Hälfte der Beschäftigten
          in diesem Beruf verdient mehr, die andere Hälfte weniger. Die gut
          bezahlten und stark gesuchten Berufe sind also oben rechts angesiedelt
          und die schlechter bezahlten und weniger gesuchten Berufe unten links.
        </Text>
        <Headline>Wie werden die Löhne ermittelt?</Headline>
        <Text>
          Die Grafik zeigt die monatlichen Bruttolöhne der
          sozialversicherungspflichtig Beschäftigten mit einer Vollzeitstelle.
          Die Daten stammen aus den Meldungen der Arbeitgeber zur
          Sozialversicherung, auf deren Basis die Beiträge etwa für die
          Rentenversicherung berechnet werden. Die Bundesagentur für Arbeit
          sammelt diese Daten in der sogenannten Entgeltstatistik. Dort sind nur
          die Löhne der Vollzeit-Beschäftigten enthalten, weil der genaue
          Arbeitsumfang der Teilzeit-Beschäftigten nicht bekannt ist. Die
          Entgelte beziehen sich auf sozialversicherungspflichtig Beschäftigte
          der sogenannten Kerngruppe, die zum Beispiel keine Auszubildenden
          enthält. Es handelt sich um Medianlöhne, das heißt die eine Hälfte der
          Beschäftigten verdient mehr, die andere weniger. Anders als
          Durchschnittslöhne werden Medianlöhne nicht höher, wenn wenige
          Beschäftigte extrem viel verdienen. Sie sind also robust gegenüber
          Ausreißern.
        </Text>
        <Headline>Wie wird die Zahl der offenen Stellen ermittelt?</Headline>
        <Text>
          Unternehmen können für die Besetzung offener Stellen die
          Arbeitsagenturen einschalten. Auf diese Weise gemeldete Stellen werden
          in der Stellenstatistik der Bundesagentur für Arbeit erfasst. Das
          Institut für Arbeitsmarkt- und Berufsforschung hat ermittelt, welcher
          Anteil der offenen Stellen insgesamt gemeldet wird. Auf Basis dieser
          Informationen wird die Zahl der offenen Stellen insgesamt mithilfe der
          gemeldeten offenen Stellen hochgerechnet. Das genaue Verfahren erklärt
          die Studie{' '}
          <a href="https://www.iwkoeln.de/fachkraefte.html" target="_blank">
            “Die Vermessung des Fachkräftemangels”.
          </a>
        </Text>
        <Headline>Warum liegen viele Kreise ganz oben?</Headline>
        <Text>
          Die Löhne basieren auf den Meldungen zur Sozialversicherung. Deren
          Beiträge werden nur bis zur Beitragsbemessungsgrenze erhoben, auch
          wenn der Lohn höher liegt. Die y-Achse für den mittleren Bruttolohn in
          Euro pro Monat für eine Vollzeitstelle endet bei 6.150 Euro. Dies
          entspricht der Beitragsbemessungsgrenze in der Rentenversicherung Ost
          im Jahr 2019. In einigen besonders gut bezahlten Berufen liegen mehr
          als die Hälfte der Arbeitnehmer und damit auch der mittlere Lohn über
          der Schwelle von 6.150 Euro. Die genaue Höhe des Medianlohns ist in
          diesen Fällen nicht bekannt. Diese Berufe liegen deshalb auf der
          oberen Linie der Grafik.
        </Text>
        <Headline>Warum liegen viele Kreise ganz links?</Headline>
        <Text>
          Im Ausgangszustand der Grafik ist die x-Achse bei einem Wert von 200
          Arbeitslosen je 100 offene Stellen begrenzt. In diesem Bereich liegen
          die meisten Berufe. Alle Berufe mit einem höheren Wert liegen auf der
          linken äußeren Linie. Wenn man den Haken bei “gesamte Skala anzeigen”
          unterhalb der Grafik setzt, erweitert sich die Skala, so dass alle
          Berufe im abgebildeten Bereich liegen.
        </Text>
        <Headline>Wie funktioniert die Berufssuche?</Headline>
        <Text>
          In der Berufsstatistik der Bundesagentur für Arbeit werden rund 1.300
          Berufsgruppen unterscheiden, obwohl es weit mehr Berufsbezeichnungen
          gibt. Eine Berufsgruppe umfasst also meist mehrere ähnliche Berufe. Um
          einen Beruf zu finden, sollte der Nutzer also den Eintrag auswählen,
          der seinem Beruf am ehesten entspricht. Wer nicht sofort fündig wird,
          kann es mit einer alternativen Bezeichnung versuchen, zum Beispiel
          Bankkaufmann statt Banker. Manchmal sind nur die deutschen Begriffe
          hinterlegt, zum Beispiel Bodensteward statt Boarding Steward. Außerdem
          führt manchmal die Bezeichnung der Ausbildung statt der genauen
          Tätigkeit zum Ziel, etwa Verwaltungsfachangestellte statt
          Ordnungsdienst.
        </Text>
        <Headline>Warum sind nicht alle Berufe enthalten?</Headline>
        <Text>
          Für einige Berufe liegen nicht genügend Daten vor, weil zu wenige
          Beschäftigte dieser Tätigkeit nachgehen oder zu wenige offene Stellen
          gemeldet sind, um verlässliche Aussagen treffen zu können. Dies
          betrifft vor allem Berufe, die seitens der Unternehmen wenig gefragt
          sind. Auch für Berufe, die häufig von Selbständigen oder Beamten
          ausgeübt werden, liegen häufig nur wenige Daten vor.
        </Text>
        <Headline>
          Warum gibt es in manchen Berufen keine Daten für die Untergruppen?
        </Headline>
        <Text>
          Die Bundesagentur für Arbeit wertet die Löhne erst ab einer
          Beschäftigtenzahl von 500 aus. Manche Berufe liegen zwar insgesamt
          über dieser Schwelle, rutschen aber für einzelne Gruppen wie Frauen
          und Männer darunter. In diesem Fall liegt nur für den Beruf insgesamt
          ein Wert vor, nicht aber für die betreffende Untergruppe.{' '}
        </Text>
        <Headline>
          Warum unterscheidet sich das Lohnniveau nach Region?
        </Headline>
        <Text>
          Nur in wenigen Berufen wird bundeseinheitlich derselbe Lohn gezahlt.
          Eine regionale Differenzierung ist üblich, zumal sich auch die
          Lebenshaltungskosten unterscheiden. In der Regel werden in
          wirtschaftsstarken Regionen höhere Löhne gezahlt als in
          strukturschwachen Gegenden.
        </Text>
        <Headline>Warum unterscheidet sich das Lohnniveau nach Alter?</Headline>
        <Text>
          Der Lohn steigt in der Regel mit der Berufserfahrung, beispielsweise
          nach einer Beförderung. In vielen Betrieben gilt zudem das sogenannte
          Senioritätsprinzip, was bedeutet, dass die Löhne mit zunehmendem Alter
          auch ohne Beförderung steigen.{' '}
        </Text>
        <Headline>
          Wie unterscheiden sich Löhne und Fachkräfteengpässe in den Sektoren?
        </Headline>
        <Text>
          In einigen Berufen werden hohe Löhne gezahlt, ohne dass
          Fachkräfteengpässe bestehen. In anderen Berufen finden die Firmen
          keine passenden Bewerber, erhöhen aber dennoch nicht die Löhne. In der
          Regel gilt aber: Beschäftigte in Berufen mit strukturellem
          Fachkräftemangel werden besser bezahlt als Beschäftigte in Berufen
          ohne Engpässe.
        </Text>
        <Headline>
          Wie hängen Qualifikation und Fachkräfteengpässe zusammen?
        </Headline>
        <Text>
          Fachkräfteengpässe kommen sowohl in Berufen vor, die eine Ausbildung
          voraussetzen, als auch in Berufen, die ein Studium verlangen. Das
          Qualifikationsniveau ist also nicht der entscheidende Faktor. Es gibt
          einige Ausbildungsberufe, die gefragter und besser bezahlt sind als
          viele Berufe für Hochschulabsolventen.
        </Text>
        <Headline>Wer hat die zugrundeliegende Studie erstellt?</Headline>
        <Text>
          Der Grafik basiert auf der Studie{' '}
          <a href="https://www.iwkoeln.de/berufe.html" target="_blank">
            “Reagieren Löhne in Deutschland auf den Fachkräftemangel?”
          </a>{' '}
          der Autoren Alexander Burstedde und Ruth Maria Schüler vom Institut
          der deutschen Wirtschaft (IW). Ein Ergebnis der Studie ist, dass es
          Hochqualifizierten deutlich besser als Beschäftigten mit mittlerer
          Qualifikation gelingt, im Fall von Fachkräfteengpässen höhere Löhne zu
          erzielen. Die Berufssuche wurde für das IW-Projekt{' '}
          <a href="https://www.kofa.de/" target="_blank">
            “Kompetenzzentrum Fachkräftesicherung”
          </a>{' '}
          entwickelt, das kleinen und mittleren Unternehmen hilft, ihren
          Fachkräftebedarf zu decken.
        </Text>
        <Headline>
          Welche Auswirkungen hat die Corona-Pandemie auf die Grafik?
        </Headline>
        <Text>
          Die zugrundeliegenden Daten stammen aus dem Jahr 2019. Die
          Auswirkungen der Corona-Pandemie sind darin also noch nicht enthalten.
          Neuere Lohndaten erscheinen im Juli 2021. Bereits jetzt verfügbare
          Daten zu Arbeitslosen und Stellen zeigen, dass Fachkräfteengpässe in
          der Regel fortbestehen, sich aber häufig verringern. Trotz dieses
          Effekts ist davon auszugehen, dass auch künftig Fachkräfte in den
          Bereichen Gesundheit, Technik und Handwerk fehlen werden.
        </Text>
      </>
    );
  }
}

export default FAQ;
